import { firestore } from "./firebase";
import { getDoc, doc, setDoc } from "firebase/firestore";

export type DaySchedule = {
  startTime: string;
  endTime: string;
  interval: number;
  active: boolean;
};

export type WorkingHours = {
  id?: string;
  "0": DaySchedule; // Domingo
  "1": DaySchedule; // Segunda
  "2": DaySchedule; // Terça
  "3": DaySchedule; // Quarta
  "4": DaySchedule; // Quinta
  "5": DaySchedule; // Sexta
  "6": DaySchedule; // Sábado
  updatedAt?: number;
};

const COLLECTION = "workingHours";

export const saveWorkingHours = async (
  data: Omit<WorkingHours, "id" | "updatedAt">
) => {
  const now = Date.now();
  await setDoc(doc(firestore, COLLECTION, "default"), {
    ...data,
    updatedAt: now,
  });
};

export const getWorkingHours = async (): Promise<WorkingHours | null> => {
  const docRef = doc(firestore, COLLECTION, "default");
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    return { id: docSnap.id, ...docSnap.data() } as WorkingHours;
  }
  return null;
};
